export const schemaTypes = [
  {
    name: 'siteSettings',
    title: 'Site Settings',
    type: 'document',
    fields: [
      { name: 'logoDarkDesktop', title: 'Logo Dark Desktop', type: 'image' },
      { name: 'logoDarkMobile', title: 'Logo Dark Mobile', type: 'image' },
      { name: 'logoLightDesktop', title: 'Logo Light Desktop', type: 'image' },
      { name: 'logoLightMobile', title: 'Logo Light Mobile', type: 'image' },
      { name: 'arrowIcon', title: 'Arrow Icon', type: 'image' },
      { name: 'hamburgerIcon', title: 'Hamburger Icon', type: 'image' },
      { name: 'ctaText', title: 'CTA Text', type: 'string' },
      { name: 'ctaUrl', title: 'CTA URL', type: 'url' },
      {
        name: 'navItems',
        title: 'Navigation Items',
        type: 'array',
        of: [{
          type: 'object',
          fields: [
            { name: 'label', type: 'string' },
            { name: 'href', type: 'string' }
          ]
        }]
      }
    ]
  },
  {
    name: 'heroSection',
    title: 'Hero Section',
    type: 'document',
    fields: [
      { name: 'tagline', type: 'string' },
      { name: 'taglineIcon', type: 'image' },
      { name: 'headlinePart1', type: 'string' },
      { name: 'headlinePart2', type: 'string' },
      { name: 'headlinePart3', type: 'string' },
      { name: 'subtext', type: 'text' },
      { name: 'ctaText', type: 'string' },
      { name: 'ctaUrl', type: 'url' },
      { name: 'heroImageDesktop', type: 'image' },
      { name: 'heroImageMobile', type: 'image' }
    ]
  },
  {
    name: 'introSection',
    title: 'Intro Section',
    type: 'document',
    fields: [
      { name: 'brandHeading', type: 'string' },
      {
        name: 'brandLogos',
        type: 'array',
        of: [{ type: 'object', fields: [{ name: 'logo', type: 'image' }] }]
      },
      { name: 'subheading', type: 'string' },
      { name: 'headingMain', type: 'string' },
      { name: 'headingHighlight', type: 'string' },
      { name: 'introImage', type: 'image' },
      {
        name: 'paragraphs',
        type: 'array',
        of: [{ type: 'object', fields: [{ name: 'text', type: 'text' }] }]
      }
    ]
  },
  {
    name: 'capabilitiesSection',
    title: 'Capabilities Section',
    type: 'document',
    fields: [
      { name: 'heading', type: 'string' },
      { name: 'highlightedText', type: 'string' },
      {
        name: 'featureCards',
        type: 'array',
        of: [{
          type: 'object',
          fields: [
            { name: 'title', type: 'string' },
            { name: 'description', type: 'text' },
            { name: 'image', type: 'image' },
            { name: 'imageMobile', type: 'image' },
            { name: 'fullSpan', type: 'boolean' }
          ]
        }]
      }
    ]
  },
  {
    name: 'benefitsSection',
    title: 'Benefits Section',
    type: 'document',
    fields: [
      { name: 'heading', type: 'string' },
      {
        name: 'benefitCards',
        type: 'array',
        of: [{
          type: 'object',
          fields: [
            { name: 'icon', type: 'image' },
            { name: 'title', type: 'string' },
            { name: 'description', type: 'text' }
          ]
        }]
      }
    ]
  },
  {
    name: 'videoSection',
    title: 'Video Section',
    type: 'document',
    fields: [
      { name: 'title', type: 'string' },
      { name: 'subtitle', type: 'string' },
      {
        name: 'languages',
        type: 'array',
        of: [{ type: 'object', fields: [{ name: 'label', type: 'string' }] }]
      },
      {
        name: 'videoLinks',
        type: 'array',
        of: [{
          type: 'object',
          fields: [
            { name: 'language', type: 'string' },
            { name: 'url', type: 'url' }
          ]
        }]
      },
      { name: 'thumbnail', type: 'image' },
      { name: 'playIcon', type: 'image' }
    ]
  },
  {
    name: 'footerSection',
    title: 'Footer Section',
    type: 'document',
    fields: [
      {
        name: 'footerLinks',
        type: 'array',
        of: [{
          type: 'object',
          fields: [
            { name: 'label', type: 'string' },
            { name: 'url', type: 'url' }
          ]
        }]
      },
      { name: 'copyrightText', type: 'string' },
      { name: 'poweredByText', type: 'string' },
      { name: 'poweredByLogo', type: 'image' },
      { name: 'followUsText', type: 'string' },
      {
        name: 'socialLinks',
        type: 'array',
        of: [{
          type: 'object',
          fields: [
            { name: 'label', type: 'string' },
            { name: 'url', type: 'url' },
            { name: 'icon', type: 'image' }
          ]
        }]
      }
    ]
  }
];
